<form name="loginForm" #loginForm="ngForm" novalidate (ngSubmit)="forward(loginForm)" autocomplete="off" [ngClass]="{'form-complete': isFormCompleted}">
    
    <!-- <mat-form-field class="w-100">
        <mat-label for="paxtype">Attendee Type</mat-label>
        <mat-select name="paxtype" id="paxtype" required [(ngModel)]="paxType" #PaxType="ngModel" matNativeControl>
          <mat-option *ngFor="let obj of paxTypeList" [value]="obj.value">{{ obj.display }}</mat-option>
        </mat-select>
        <mat-error><app-validation  [object]="PaxType" isRequired=true></app-validation></mat-error>
      </mat-form-field>
      <mat-form-field class="w-100">
        <mat-label for="loginID" [ngClass]="{'active' : loginID}">{{ 'copy.label.FEATURES.EMAIL.label' | copy | async }}</mat-label>
        <input matInput type="text" name="loginID" id="loginID" maxlength="100" [(ngModel)]="loginID" pattern="[a-zA-Z0-9._'%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,125}[a-zA-Z]{2,63}" #theloginID="ngModel" required/>
        <mat-error><app-validation  [object]="theloginID" isRequired=true pattern="email"></app-validation></mat-error>
      </mat-form-field> -->
      <div [innerHTML]='"copy.html.onsiteLoginText"|copy|async'></div>
    <!-- <mat-form-field class="w-100" ng-if="loginCtrl.programInfo.regCode">
        <mat-label [ngClass]="{'active' : regcode}" for="regcode">{{"copy.label.LOGIN.regcode.label"|copy|async}}</mat-label>
        <input matInput type="text" name="regcode" id="regcode" aria-label="Registration/Promo code" [(ngModel)]="regcode" alphanum />
    </mat-form-field> -->
    <div class="button_group d-flex">
        <a href="http://www.osaicconnected.com/" ><button class="forward btn btn-primary" type="button" *ngIf="!isSubmitting">Return to ConnectED Home Page</button></a>

        <!-- <button aria-label="Decline" class="back btn btn-outline-primary" type="button" (click)="declineButtonClick( )" *ngIf="!isSubmitting">Decline</button> -->
        <!-- <button class=" inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
        </button>
        <button *ngIf="!isSubmitting" name="new-login-button" type="submit" aria-label="Submit" class="forward btn btn-primary">{{'copy.label.LOGIN.newlogin.button'|copy|async}}</button> -->
    </div>
    <!-- <span class="help-block"><a tabindex="0" (click)="openModal('LoginRegHelp', 'Registration Help', 'Close')" (keydown.enter)="openModal('LoginRegHelp', 'Registration Help', 'Close')">{{"copy.label.LOGIN.newlogin.help"|copy|async}}</a></span> -->

    <div *ngIf="errorMsg" type="danger">
        <strong>
            <span class="fas fa-stack">
            <i class="fas fa-exclamation fa-stack-1x"></i>
            <i class="far fa-circle fa-stack-2x"></i>
            </span>
            {{errorMsg}}
        </strong>
    </div>
</form>